
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      title: "Staff | Bikeflights.com",
      staff: [
        {
          picture: "b_alcorn",
          name: "William Alcorn",
          role: "President",
        },
        {
          picture: "s_george",
          name: "Sue George",
          role: "Vice President",
        },
        {
          picture: "MichaelPotter_696_435",
          name: "Michael Potter",
          role: "Partnership Director",
        },
        {
          picture: "n_chretien",
          name: "Nicole Chretien",
          role: "Ship Manager",
        },
        {
          picture: "k-sanchez",
          name: "Kent Sanchez",
          role: "Delivery Manager",
        },
        {
          picture: "b-clancey",
          name: "Brenna Clancey",
          role: "International Manager",
        },
        {
          picture: "gina-perschbacher",
          name: "Gina Harvey",
          role: "Orders Team Manager",
        },
        {
          picture: "ilifan-irwin",
          name: "Lifan Irwin",
          role: "Customer Experience Lead",
        },
        {
          picture: "staff-michael-utley",
          name: "Michael Utley",
          role: "Customer Experience Lead",
        },
        {
          picture: "a_goulet",
          name: "Ali Goulet",
          role: "Customer Experience Associate",
        },
        {
          picture: "justin-barr",
          name: "Justin Barr",
          role: "Customer Experience Associate",
        },
        {
          picture: "Mick-Wolf",
          name: "Mick Wolf",
          role: "Customer Experience Associate",
        },
        {
          picture: "MJ-Baumgart",
          name: "MJ Baumgart",
          role: "Customer Experience Associate",
        },
        {
          picture: "v_camiolo",
          name: "Vince Camiolo",
          role: "Customer Experience Associate",
        },
        {
          picture: "PatriciaS",
          name: "Patricia Schwager",
          role: "Customer Experience Associate",
        }
      ],
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
});
